import React from "react";
import {Document, Page, Text, View} from '@react-pdf/renderer';
import {PdfPostControlDocumentAttachments} from './PdfPostControlDocumentAttachments';
import {stylesForPdf} from './PdfPostControlStyling';
import {renderOrdersTable} from './PdfPostControlOrders';
import {getTextWithLines, getDividedStringIntoSpans} from '../documents/helpers';
import {isWTrakcieRealizacji} from "../ControlStateHelper";
import {formatCurrency, mapOrderNumber,numberFindingsByBlock } from '../ControlStateHelper.ts';
import {draftjsToString} from "../WysiwygEditor/WysiwygHelpers";
import {groupBy, sortBy} from "lodash";

export default class PdfInfo extends React.Component {


    // renderBlocks, renderFindings, renderRecommendations przekopiowane z PostControlInfoDetail
    // i dostosowane do wymagań dotyczących dokumentu Pdf

    printPickedWops = (control) => {
		let wopsCollection = control.paymentClaims;
		if (wopsCollection?.length > 0) {
			return <Text style={stylesForPdf.tableCol60}>{wopsCollection.map(item => item.number).join(', ').match(/.{1,5}/g)}</Text>;
		} else {
			return <Text style={stylesForPdf.tableCol60}>Brak kontrolowanych wniosków.</Text>
		}
	};

    renderBlocks() {
        this.info = this.props.infoData;
        if (this.info) {

            if(this.info.findings.length === 0) {
                return (
                    <View>
                        <Text>Brak.</Text>
                    </View>
                );
            }

            const sortedBlockNames = this.info.findings.map(f => f.blockInList).sort((a, b) => a.id - b.id).map(x => x.name);

            let uniqueBlockNames = new Set(sortedBlockNames);

            uniqueBlockNames = [...uniqueBlockNames];

            return uniqueBlockNames.map((blockName, blockIndex) => {
                return (
                    <View key={blockName}>
                        {this.renderFindings(blockName, blockIndex)}
                    </View>
                )
            });
        }
    }


    isFinancial(finding) { return finding.corrections.filter(x => !x.toRemove).length > 0; }

    renderFindings(blockName, blockIndex) {
        let findingsInBlock = this.info.findings.filter(finding => {
            return finding.blockInList.name === blockName
        });

        const userFacingBlockIndex = blockIndex + 1;

        const CHAPTER = `Ustalenie nr ${userFacingBlockIndex}.`;
        var counter = 0;

        return findingsInBlock.map(finding => {
            counter += 1;
            let isFinancial = this.isFinancial(finding);

            return (<View key={finding.id}>
                <Text style={stylesForPdf.finding}>
                    {`${CHAPTER}${counter} ${blockName} `?.match(/.{1,5}/g)}
                </Text>
                <Text style={stylesForPdf.findingName}>
                    {draftjsToString(finding.title)}
                </Text>

                <View style={[stylesForPdf.findingRow, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap'  }]}>
                    <Text style={{fontWeight: 'bold'}}>Ustalenie finansowe: </Text>
                    <Text style={{fontWeight: 'normal'}}>{`${isFinancial ? 'Tak' : 'Nie'}`}</Text>
                </View>

                {(isFinancial && finding.findingKind)
                    ? <View style={[stylesForPdf.findingRow, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap'  }]}>
                        <Text style={{fontWeight: 'bold'}}>Typ ustalenia finansowego: </Text>
                        <Text style={{fontWeight: 'normal'}}>{`${finding.findingKind?.code} ${finding.findingKind?.name}`.match(/.{1,5}/g)}</Text>
                    </View>
                    : <Text></Text>
                }

                <View style={[stylesForPdf.findingRow, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }]}>
                    <Text style={{fontWeight: 'bold'}}>Szczegóły ustalenia</Text>
                    <Text style={{fontWeight: 'normal'}}>{draftjsToString(finding.content)}</Text>
                </View>

                <View style={[stylesForPdf.findingRow, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap'  }]}>
                    <Text style={{fontWeight: 'bold'}}>{`Zalecenia związane z ustaleniem nr ${userFacingBlockIndex}.${counter}: `}</Text>
                    <Text style={{fontWeight: 'normal'}}>{`${finding.recommendations.length === 0 ? 'Brak.' : ''}`}</Text>
                </View>

                {finding.recommendations.map((rec, recIndex) => {
                    const findingNumber = finding.number || `${userFacingBlockIndex}.${counter}`;
                    return (
                        <View style={[stylesForPdf.findingRow, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap'  }]}>
                            <Text style={{fontWeight: 'bold'}}>{`Zalecenie ${findingNumber}.${recIndex+1}`}</Text>
                            <Text style={{fontWeight: 'normal'}}>{draftjsToString(rec.recommendationText)}</Text>
                        </View>
                    )
                })}

            </View >)
        });
    }

    // przekopiowane z komponentu financialTable i dostosowane

renderFinancialFindings = () => {
        const numberedFindings = numberFindingsByBlock(this.props.infoData.findings || []);
        const findings = numberedFindings.filter(f => f.corrections.length > 0);

        const groupedBlocks = groupBy(numberedFindings, 'blockInList.id');
        const blocks = Object.keys(groupedBlocks)
            .sort((a, b) => parseInt(a) - parseInt(b))
            .reduce((sortedObj, blockId) => {
                sortedObj[blockId] = sortBy(groupedBlocks[blockId], 'id');
                return sortedObj;
            }, {});
        
        let correctionCounter = 0;
        if (findings.length > 0) {
            return <View style={stylesForPdf.ftabTable}>
                <View wrap={false} style={stylesForPdf.ftabHeaderRow}>
                    <View style={{width: '7%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>L.p.</Text></View>
                    <View style={{width: '10%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Numer ustalenia</Text></View>
                    <View style={{width: '15%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Typ ustalenia</Text></View>
                    <View style={{width: '10%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Korekta kosztów pośrednich</Text></View>
                    <View style={{width: '10%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Rodzaj korekty</Text></View>
                    <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Stawka korekty</Text></View>
                    <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Podstawa korekty</Text></View>
                    <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Kwota wydatków niekwalifikowalnych</Text></View>
                    <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Projekt</Text></View>
                    <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Wniosek o płatność</Text></View>
                    <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text style={stylesForPdf.verticalCenter}>Zamówienia publiczne</Text></View>
                </View>
                {Object.keys(blocks).flatMap((blockId, blockIndex) => {
                    return blocks[blockId]
                        .filter(finding => finding.corrections.length > 0)
                        .map((finding, findingIndexInBlock) => {
                            const findingNumber = finding.number || `${blockIndex + 1}.${findingIndexInBlock + 1}`;
                            let renderedCorrections = this.renderCorrections(finding, correctionCounter, findingNumber);
                            correctionCounter += finding.corrections.filter(correction => !correction.toRemove).length;
                            return renderedCorrections;
                        });
                })}
            </View>
        }

    };

    getOrderNumber = (referenceId) => this.props.control?.orders?.find(o => o.id === referenceId)?.orderNumber || '';

    renderCorrections(finding, correctionCounter, findingNumber) {
        let corrections = finding.corrections;
        return finding.corrections.filter(correction => !correction.toRemove).map((c, i) => {

            correctionCounter += 1;

            return <View wrap={false} style={stylesForPdf.ftabRow} key={corrections.indexOf(c)}>
                <View style={{width: '7%', ...stylesForPdf.ftabCell}}><Text>{correctionCounter}</Text></View>
                <View style={{width: '10%', ...stylesForPdf.ftabCell}}><Text>{findingNumber?.split('')}</Text></View>
                <View style={{width: '15%', ...stylesForPdf.ftabCell}}><Text> {finding?.findingKind ? finding.findingKind?.name.split('') : ''}</Text></View>
                <View style={{width: '10%', ...stylesForPdf.ftabCell}}><Text>{c.indirectCosts === true ? 'Tak' : c.indirectCosts === false ? 'Nie' : ''}</Text></View>
				<View style={{width: '10%', ...stylesForPdf.ftabCell}}><Text>{c.kind.split('')}</Text></View>
                <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text>{c.rate !== null ? formatCurrency(c.rate, 2) + "%" : ''}</Text></View>
                <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text>{c.base !== null ? formatCurrency(c.base, 2).split('') : ''}</Text></View>
                <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text>{formatCurrency(c.wrongExpenditure, 2).split('')}</Text></View>
                <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text>{c.projectNumber.split('')}</Text></View>
                <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text>{c.paymentClaim ? c.paymentClaim.number.split('') : "brak"}</Text></View>
                <View style={{width: '8%', ...stylesForPdf.ftabCell}}><Text>{(c.order && c.order.referenceId) ? mapOrderNumber(c.order.referenceId, this.props.control?.orders).split('') : c.order?.orderNumber ? c.order?.orderNumber.split('') : "brak"}</Text></View>
            </View>
        })
    }

    isNotDraft = (control, infoData) => {
        const isCompleateDate = infoData?.isFinalInfo ? infoData?.finalInfoSendDate : infoData?.receivedByControlledEntityDate;
        return (isWTrakcieRealizacji(control) && isCompleateDate) || !isWTrakcieRealizacji(control)
    };

    render = () => {
        let {control, checklistVersionInfo, infoData, infoNumber, abbrevs} = this.props;
        let generationTime = new Date(Date.now()).toLocaleString();
        const isMyControl = window.location.pathname.startsWith("/my_controls")
        const isDraft = !this.isNotDraft(control, infoData) && !isMyControl;
        const isListValidated = infoData.isValidated;
        return (
            <Document>
                <Page style={stylesForPdf.body}>

                    {/* nagłówek */}
                    <Text style={stylesForPdf.pageHeader} fixed>
                        {`${infoNumber}\nUtworzono ${generationTime}`}
                    </Text>

                    {/* tytuł dokumentu */}
                    <View>
                        {isDraft && <Text style={stylesForPdf.draft} fixed>WERSJA ROBOCZA</Text>}
                        <Text style={stylesForPdf.mainTitleInVER2}>{`${infoData?.isFinalInfo ? 'OSTATECZNA I' : 'I'}NFORMACJA POKONTROLNA\n${infoNumber}`}</Text>
                    </View>

                    {/* informacje wstępne */}
                    <View>
                        <Text style={stylesForPdf.sectionTitle}>Informacje wstępne</Text>
                    </View>
                    <View style={stylesForPdf.sectionTitle2View}>
                    <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Informacje o projekcie')}</Text>
                    </View>
                    <View style={stylesForPdf.tableFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Numer kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.number}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Numer projektu:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.metadata.businessId}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Tytuł projektu:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.title}</Text>
                        </View>
                    </View>

                    {/* Dane beneficjenta */}
                    <View style={stylesForPdf.sectionTitle2View}>
                        <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Dane beneficjenta')}</Text>
                    </View>
                    <View style={stylesForPdf.tableFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Identyfikator beneficjenta:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.beneficiaryIdentityNumber}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Nazwa beneficjenta:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.beneficiaryName}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Adres beneficjenta:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.beneficiaryAddress}</Text>
                        </View>
                    </View>

                    {/* Informacje o kontroli */}
                    <View style={stylesForPdf.sectionTitle2View}>
                        <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Informacje o kontroli')}</Text>
                    </View>
                    <View style={stylesForPdf.tableTopFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Tryb kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlMode}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Typ kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlType}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Rodzaj kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlKind}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Zespół kontrolujący:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlTeam}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Zastosowana lista sprawdzająca:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.questionList.name}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Wersja listy sprawdzającej:</Text>
                            <Text style={stylesForPdf.tableCol60}>{checklistVersionInfo}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Planowany termin kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.plannedTerm}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Data rozpoczęcia kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.term}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Podmiot kontrolujący:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.controllingEntity || 'Brak.').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Podmioty kontrolowane:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.allControlledParties || 'Brak.').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Miejsca przeprowadzenia kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.controlPlaces && control.controlPlaces.length > 0 ? control.controlPlaces.map(p => p.name).join("; ") : 'Brak.').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Inne kontrolowane projekty:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.otherControlledProjectNumbers && control.otherControlledProjectNumbers.length > 0 ? control.otherControlledProjectNumbers.join("; ") : 'Brak innych kontrolowanych projektów.').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Kontrolowane zamówienia:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(!control.orders || control.orders?.length === 0 ? 'Brak kontrolowanych zamówień.' : '').split('')}</Text>
                        </View>
                    </View>
                    {renderOrdersTable(this.props.control.orders)}
                    <View style={!control.orders || control.orders?.length === 0 ? stylesForPdf.tableBottomNoMarginFullWidth : stylesForPdf.tableBottomFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Numery kontrolowanych WoP:</Text>
                            {this.printPickedWops(control)}
                        </View>
                    </View>

                    {/* wykaz skrótów */}
                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>1. Wykaz skrótów</Text>
                    </View>

                    <View>
                        <Text style={stylesForPdf.textLine}>
                            {abbrevs && abbrevs.length > 0 ? draftjsToString(abbrevs) : !!isListValidated ? 'Brak.' : ''}
                        </Text>
                    </View>


                    {/* podstawa, cel, przedmiot */}
                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>2. Podstawa prawna</Text>
                    </View>

                    <View>
                        <Text style={stylesForPdf.textLine}>{draftjsToString(infoData.legalBasis)}</Text>
                    </View>

                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>3. Cel kontroli</Text>
                        <Text style={stylesForPdf.textLine}>{draftjsToString(infoData.controlPurpose)}</Text>
                    </View>

                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>4. Przedmiot kontroli</Text>
                        <Text style={stylesForPdf.textLine}>{draftjsToString(infoData.controlSubject)}</Text>
                    </View>


                    {/* ustalenia */}
                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>5. Ustalenia i zalecenia pokontrolne</Text>
                        {this.renderBlocks()}
                    </View>

                    {/* podsumowanie */}
                    <Text style={stylesForPdf.sectionBlockTitleINF}>6. Podsumowanie ustaleń finansowych</Text>

                    {this.props.infoData.findings.length > 0 && this.props.infoData.findings.some(x => x.isFinancial) ? (this.props.infoData.findings.filter(f => f.corrections.length !== 0).length > 0 ?
                        this.renderFinancialFindings() : null) : (<Text>Brak ustaleń finansowych.</Text>)}

                    {this.props.infoData.financialFindingsNotes && (
                        <View style={{marginTop: 10}}>
                            <Text style={{...stylesForPdf.textLine, fontWeight: 'bold'}}>Uwagi do ustaleń finansowych:</Text>
                            <Text style={stylesForPdf.textLine}>{draftjsToString(this.props.infoData.financialFindingsNotes)}</Text>
                        </View>
                    )}

                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>7. Podsumowanie kontroli</Text>
                        <Text style={stylesForPdf.textLine}>{draftjsToString(infoData.controlSummary)}</Text>
                    </View>

                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>8. Pouczenie końcowe</Text>
                        <Text style={stylesForPdf.textLine}>{draftjsToString(infoData.finalInstructions)}</Text>
                    </View>

                    <View>
                        <Text style={stylesForPdf.sectionBlockTitleINF}>9. Załączniki</Text>
                            <PdfPostControlDocumentAttachments attachments={control.documents} attachmentsInDocument={infoData.attachments} />
                    </View>

                    {/* stopka */}
                    <Text style={stylesForPdf.pageNumber} render={({ pageNumber, totalPages }) => (
                        `Strona ${pageNumber} z ${totalPages}`
                    )} fixed />
                </Page>
            </Document>
        )
    };
}
